export const enum AdminRequestTabs { Requests = 1, Planning = 2, RequestRegistrations = 3 }
export const isRequestTabSelected = (selectedTab: AdminRequestTabs) => selectedTab === AdminRequestTabs.Requests;
export const isPlanningTabSelected = (selectedTab: AdminRequestTabs) => selectedTab === AdminRequestTabs.Planning;
export const isRequestRegistrationsTabSelected = (selectedTab: AdminRequestTabs) => selectedTab === AdminRequestTabs.RequestRegistrations;
